import { CircularProgress } from "@material-ui/core";
import React from "react";

export const standardAuthConfig = {
    loadingComponent: <CircularProgress size={40} />,
    redirect: "/login" // redirect to this url
};
